const initialState = { ids: [], entities: {} };
export default function reducer(state = initialState /* , action */) {
  return state;
}

export const selectors = {
  getAllLanguages(state) {
    return state.languages.ids.map(id => state.languages.entities[id]);
  },
  geti18nLanguages(state) {
    return state.languages.ids.map(id => state.languages.entities[id]).filter(lang => lang.code !== null);
  },
};
